import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export class Helpers {
  /*-------------------------- Mask For Phones ----------------------------------*/

  public static PhoneMaskEditing = (e: { target: { value: string } }) => {
    const value = e.target.value.replace(/\D/g, ''); // Remove todos os caracteres n�o num�ricos
    //value = value.slice(0, 11); // Limita o comprimento m�ximo do valor para 11 caracteres
    if (value.length === 0) e.target.value = '';
    else if (value.length <= 2) e.target.value = `(${value}`;
    else if (value.length <= 7)
      e.target.value = `(${value.slice(0, 2)}) ${value.slice(2)}`;
    else if (value.length <= 10)
      e.target.value = `(${value.slice(0, 2)}) ${value.slice(2, 6)}-${value.slice(6)}`;
    else
      e.target.value = `(${value.slice(0, 2)}) ${value.slice(2, 6)}-${value.slice(6, 10)}`;
    return value;
  };

  public static PhoneMaskShowing = (field: string) => {
    let phoneMasked = '';

    if (field === null) {
      return phoneMasked;
    } else if (field.length === 10) {
      phoneMasked = `(${field.slice(0, 2)}) ${field.slice(2, 6)}-${field.slice(6, 10)}`;
    }

    return phoneMasked;
  };

  /*------------------------ END Mask For Phones ----------------------------------*/

  /*-------------------------- Mask For CellPhones ----------------------------------*/

  public static CellPhoneMaskEditing = (e: { target: { value: string } }) => {
    const value = e.target.value.replace(/\D/g, ''); // Remove todos os caracteres n�o num�ricos
    //value = value.slice(0, 11); // Limita o comprimento m�ximo do valor para 11 caracteres
    if (value.length === 0) e.target.value = '';
    else if (value.length <= 2) e.target.value = `(${value}`;
    else if (value.length <= 7)
      e.target.value = `(${value.slice(0, 2)}) ${value.slice(2)}`;
    else if (value.length <= 11)
      e.target.value = `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(7)}`;
    else
      e.target.value = `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(7, 11)}`;
    return value;
  };

  public static CellPhoneMaskShowing = (field: string) => {
    let phoneMasked = '';

    if (field === null) {
      return phoneMasked;
    } else if (field.length === 11) {
      phoneMasked = `(${field.slice(0, 2)}) ${field.slice(2, 7)}-${field.slice(7, 11)}`;
    }

    return phoneMasked;
  };

  /*------------------------ END Mask For CellPhones ----------------------------------*/

  /*------------------------ Dynamic Mask For CellPhones and Phones -------------------*/
  public static DynamicPhoneMaskEditing = (e: { target: { value: string } }) => {
    const value = e.target.value.replace(/\D/g, '');

    if (value.length === 0) e.target.value = '';
    else if (value.length <= 2) e.target.value = `(${value}`;
    else if (value.length <= 6)
      e.target.value = `(${value.slice(0, 2)}) ${value.slice(2)}`;
    else if (value.length <= 10)
      // Telefone fixo: (XX) XXXX-XXXX
      e.target.value = `(${value.slice(0, 2)}) ${value.slice(2, 6)}-${value.slice(6)}`;
    else
      // Celular: (XX) XXXXX-XXXX
      e.target.value = `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(7, 11)}`;

    return value;
  };
  /*------------------------ END Dynamic Mask For CellPhones and Phones ---------------*/

  /*------------------------ Mask For Dates -------------------------------------------*/

  // For�ar a Table exibir sempre as datas no padr�o PT-BR independente da regi�o
  public static DateFormatTableShowing = (field: Date | string) => {
    let date = '';

    if (field !== null) {
      date = format(new Date(field), 'dd/MM/yyyy', { locale: ptBR });
    }

    return date;
  };

  // Os Fields do tipo data ir�o formatar as datas de acordo com a regi�o da m�quina
  public static DateFormatFieldShowing = (field: Date | string) => {
    //const locale = navigator.language === 'pt-BR' ? ptBR : enUS;

    let date = '';

    if (field !== null) {
      date = format(new Date(field), 'yyyy-MM-dd', { locale: ptBR });
    }

    return date;
  };

  /*------------------------ END Mask For Dates ----------------------------------------*/
}
